/** @jsxImportSource @emotion/react */
import React, { createContext } from 'react'
import { SWRRootContextType } from './types'

/**
 * this function generates a default SWR root context
 * @return {React.Context} - the default SWR root context
 */
export function createRootContext(): React.Context<SWRRootContextType> {
  return createContext({} as SWRRootContextType)
}

export default createRootContext()
